import React from 'react';
import { TextField, Typography, Stack } from '@mui/material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';

interface CheckpointLinkProps {
  checkpoint: ExecuteCheckpointDef;
  value: unknown;
  onChange: (value: string) => void;
  error?: string;
  isReadOnly?: boolean;
}

export const CheckpointLink: React.FC<CheckpointLinkProps> = ({
  checkpoint,
  value,
  onChange,
  error,
  isReadOnly,
}) => {
  const allowedTypes = checkpoint.allowedEntityTypes ?? [];

  return (
    <Stack spacing={0.5}>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        {checkpoint.checkpointName}
        {checkpoint.required && <Typography component="span" color="error"> *</Typography>}
      </Typography>
      {allowedTypes.length > 0 && (
        <Typography variant="caption" color="text.secondary">
          Allowed: {allowedTypes.join(', ')}
        </Typography>
      )}
      <TextField
        size="small"
        fullWidth
        placeholder="Search entity…"
        value={typeof value === 'string' ? value : ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={isReadOnly}
        error={Boolean(error)}
        helperText={error}
      />
    </Stack>
  );
};
